import { ThemeContext } from "./ThemeContext";
import React, {useContext} from "react";

function DarkMode() {
    const {toggleFunction, toggle } = useContext(ThemeContext)
    return(
        <div className="App">
        <br/>
        <button type="button" className="button-theme" onClick={toggleFunction} style={toggle ? {color: "white", backgroundColor: "black"} : {color: "black", backgroundColor: "white"}}>
          Change Navbar to {toggle ? "Dark" : "Light"} theme
        </button>
        </div>
    );
}

export default DarkMode